export function getFetchUrl(request) {
    return `/api/${request}`
}

export function getDefaultHeaders() {
    return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAccessKey()}`
    }
}

export function getAccessKey() {
    return $.cookie('tictukMng_accessKey')
}

export function stringifyPayload(data) {
    const copy = { ...data }

    Object.entries(copy)
        .filter(([, value]) => value === null)
        .forEach(([key]) => {
            delete copy[key]
        })

    return JSON.stringify(copy)
}
